module.exports = __webpack_public_path__ + "img/icb-leo-Inte-e@3x.695b195f.png";